<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 26 26"
    preserveAspectRatio="xMinYMin meet"
    class="icon"
  >
    <g>
      <path
        style="text-indent:0;text-align:start;line-height:normal;text-transform:none;block-progression:tb;-inkscape-font-specification:Bitstream Vera Sans"
        d="M 9.5 0 C 7.6548443 0 6.0301713 0.72532635 5.125 2 C 4.2198287 3.2746736 4 4.8368815 4 6.5 L 4 21.5 A 1.50015 1.50015 0 1 0 7 21.5 L 7 18.78125 L 16 20.28125 L 16 24.5 A 1.50015 1.50015 0 1 0 19 24.5 L 19 8.5 C 19 7.159285 19.256765 6.2244516 19.59375 5.75 C 19.930735 5.2755484 20.313764 5 21.5 5 A 1.50015 1.50015 0 1 0 21.5 2 C 19.655236 2 18.030265 2.7254516 17.125 4 C 16.271825 5.2012096 16.025286 6.6627213 16 8.21875 L 7 6.71875 L 7 6.5 C 7 5.1591185 7.2569213 4.2243264 7.59375 3.75 C 7.9305787 3.2756736 8.3131557 3 9.5 3 A 1.50015 1.50015 0 1 0 9.5 0 z M 7 8.78125 L 16 10.28125 L 16 13.21875 L 7 11.71875 L 7 8.78125 z M 7 13.78125 L 16 15.28125 L 16 18.21875 L 7 16.71875 L 7 13.78125 z"
        overflow="visible"
        enable-background="accumulate"
        font-family="Bitstream Vera Sans"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: "queue"
};
</script>
<style scoped>
.icon {
  fill: currentColor;
}
</style>
